
export function getNumberFromThousandsString(thousands: string | number): number {
    return Number.parseInt(thousands.toString().split(' ').join(''))
}